import React, { useState } from 'react';
import { Button, message } from 'antd';
import { Price } from '@partsbadger/library';
import { PlusOutlined } from '@ant-design/icons';

interface Props {
    quantity: number;
    unit_price: number;
    total_price: number;
    onClick: () => Promise<any>;
}

const QuotedQuantity = (props: Props) => {
    const [addingItem, setAddingItem] = useState<boolean>(false);

    const { quantity, unit_price, total_price } = props;

    return (
        <>
            <td className="ant-table-cell">{quantity}</td>
            <td className="ant-table-cell">
                <Price value={unit_price} />
            </td>
            <td className="ant-table-cell">
                <Price value={total_price} />
            </td>
            <td className="ant-table-cell">
                <Button
                    size={'small'}
                    style={{
                        color: 'green',
                    }}
                    loading={addingItem}
                    onClick={() => {
                        setAddingItem(true);
                        props
                            .onClick()
                            .then(() => {
                                message.success('Item Added!');
                            })
                            .finally(() => setAddingItem(false))
                            .catch(() => {
                                message.error('Something went wrong!');
                            });
                    }}
                >
                    <PlusOutlined /> Add To Order
                </Button>
            </td>
        </>
    );
};

export default QuotedQuantity;
